import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";


const BecomeSellerPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />


      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default BecomeSellerPage;